export default "__VITE_ASSET__DrQDRX$P__"